import ApiService from "../../../utils/api.service";
export default {
    list(context){
        return new Promise(resolve => {
            ApiService.get("v1/billing/cards-list")
              .then(({ data }) => {      
                context.commit("set_list", data);
                resolve(data);
              })
          });
    },
    create(context, model){
        return new Promise(resolve => {
            ApiService.post("v1/billing/card", model)
              .then(({ data }) => {      
                context.commit("set_list", data);
                resolve(data);
              })
          });
    }
}